import {
  Directive,
  ElementRef,
  HostListener,
  Renderer2,
} from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'button[nbButton]',
})
export class DefaultButtonTypeDirective {
  constructor(
    private readonly elementRef: ElementRef<HTMLButtonElement>,
    private readonly renderer: Renderer2
  ) {
    const button = this.elementRef.nativeElement;

    if (!button.hasAttribute('type')) {
      this.renderer.setAttribute(button, 'type', 'button');
    }
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent): void {
    event.stopPropagation();
  }

  @HostListener('mouseup', ['$event'])
  onMouseUp(event: MouseEvent): void {
    event.stopPropagation();
  }

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    event.stopPropagation();
  }
}
